export const generatedScenarioDiligenceWorkOrderLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-21T00:00:00.000Z",
  "mode": "deterministic-scenario-diligence-work-order-ledger",
  "operatingRule": "Scenario diligence work orders convert evidence gaps and customer decision dossiers into executable paid-beta research tasks with acceptance gates, affected packages, replay commands, and decision-delta requirements. They are not verified science or customer/commercial clearance.",
  "workOrderCount": 12,
  "blockedWorkOrderCount": 12,
  "p0WorkOrderCount": 3,
  "coveredP0GapCount": 3,
  "p0GapCount": 3,
  "laneCounts": {
    "runtime-validation": 3,
    "process-physics": 3,
    "release-proof": 1,
    "resource-confidence": 4,
    "economics-sensitivity": 1
  },
  "priorityCounts": {
    "P0-critical-path": 3,
    "P1-business-grade": 9
  },
  "customerUseAllowed": false,
  "commercialUseAllowed": false,
  "evidenceHashes": {
    "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
    "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
    "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
    "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
    "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
    "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
    "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
    "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
  },
  "p0GapIds": [
    "gap-runtime-orekit-propagation-v1",
    "gap-runtime-gmat-transfer-v1",
    "gap-runtime-tudat-transfer-v1"
  ],
  "coveredP0GapIds": [
    "gap-runtime-gmat-transfer-v1",
    "gap-runtime-orekit-propagation-v1",
    "gap-runtime-tudat-transfer-v1"
  ],
  "workOrders": [
    {
      "id": "diligence-work-order-01-gap-runtime-orekit-propagation-v1",
      "linkedExperimentId": "experiment-01-gap-runtime-orekit-propagation-v1",
      "linkedExperimentHash": "sha256-2b3b43263ea3d54353e5cce4ed1797cbf0fde1e8899e70559b44131d761f551d",
      "linkedGapId": "gap-runtime-orekit-propagation-v1",
      "linkedGapHash": "sha256-d7b3370f7e30f22d9384b036fb636c0360a352e5ad7477c300a9e2896af9901d",
      "lane": "runtime-validation",
      "priorityLane": "P0-critical-path",
      "priorityScore": 78,
      "title": "Test whether resolving Orekit runtime artifact promotion changes feasibility ranking confidence",
      "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
      "affectedPackageIds": [
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "upstreamAffectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "unmappedScenarioIds": [],
      "scenarioRefs": [
        {
          "scenarioId": "mercury-orbit",
          "dossierId": "customer-dossier-mercury-orbit",
          "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 44.15,
          "uncertaintyBudgetPoints": 65.61,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        },
        {
          "scenarioId": "hybrid",
          "dossierId": "customer-dossier-hybrid",
          "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 59.78,
          "uncertaintyBudgetPoints": 43.88,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        }
      ],
      "requiredInputs": [
        "Runtime-generated sidecar artifact matching the contract.",
        "Tool/environment version and reproducible command.",
        "Inputs, outputs, and checksum hashes.",
        "Independent comparison with residual bounds.",
        "Reviewed sidecar intake report in evidence/sidecar-intake-reports."
      ],
      "sourceIds": [
        "orekit"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass.",
        "Customer-use state remains blocked unless source-use rights, runtime validation, economics/materials/resource gates, and reviewer approvals all pass.",
        "A before/after decision-delta artifact is generated and hash-linked to the customer decision dossier ledger."
      ],
      "decisionDeltaContract": {
        "baselineRunLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "comparisonLedgerHash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "scenarioDeltas": [
          {
            "scenarioId": "mercury-orbit",
            "currentRank": 4,
            "currentDecisionLane": "lane-4-research-backlog",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 44.15,
            "currentUncertaintyBudgetPoints": 65.61,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110"
          },
          {
            "scenarioId": "hybrid",
            "currentRank": 2,
            "currentDecisionLane": "lane-3-watchlist",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 59.78,
            "currentUncertaintyBudgetPoints": 43.88,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ],
        "requiredAfterRunFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "replayContract": {
        "planningCommand": "npm run science:report",
        "focusedTestCommand": "node --test tests/scenario-diligence-work-order-ledger.test.mjs",
        "browserProofCommand": "npm run test:browser",
        "expectedOutput": "public/scenario-diligence-work-order-ledger.json",
        "replayBoundary": "This work order scopes diligence execution only. It does not generate the missing source/runtime evidence and cannot promote customer or commercial claims."
      },
      "governance": {
        "currentState": "work-order-planned-blocked-until-evidence",
        "customerUseAllowed": false,
        "commercialUseAllowed": false,
        "sourceUseCustomerAllowed": false,
        "platformRuntimeReady": false,
        "modelValidationCommercialUseAllowed": false,
        "blockedPromotionBoundary": "Treat this as paid-beta diligence backlog, not verified science, legal clearance, operational mission design, investment advice, or resource certification."
      },
      "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
      "evidenceHashes": {
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
      },
      "workOrderHash": "sha256-baa82fd4ea74aad62b55dfc56fd78e1513cac8ba3a0e6cbc136c02b3d128e4d1"
    },
    {
      "id": "diligence-work-order-02-gap-runtime-gmat-transfer-v1",
      "linkedExperimentId": "experiment-02-gap-runtime-gmat-transfer-v1",
      "linkedExperimentHash": "sha256-1f2a9b1e8259fc195f0ca63dafe80764be5835aca882c588e05bddecd2415403",
      "linkedGapId": "gap-runtime-gmat-transfer-v1",
      "linkedGapHash": "sha256-db779e0c99ffc0487e63be269cff1d79a58b41e37c1c765b0ccee4aacda80d00",
      "lane": "runtime-validation",
      "priorityLane": "P0-critical-path",
      "priorityScore": 77,
      "title": "Test whether resolving NASA GMAT runtime artifact promotion changes feasibility ranking confidence",
      "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
      "affectedPackageIds": [
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "upstreamAffectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "unmappedScenarioIds": [],
      "scenarioRefs": [
        {
          "scenarioId": "mercury-orbit",
          "dossierId": "customer-dossier-mercury-orbit",
          "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 44.15,
          "uncertaintyBudgetPoints": 65.61,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        },
        {
          "scenarioId": "hybrid",
          "dossierId": "customer-dossier-hybrid",
          "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 59.78,
          "uncertaintyBudgetPoints": 43.88,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        }
      ],
      "requiredInputs": [
        "Runtime-generated sidecar artifact matching the contract.",
        "Tool/environment version and reproducible command.",
        "Inputs, outputs, and checksum hashes.",
        "Independent comparison with residual bounds.",
        "Reviewed sidecar intake report in evidence/sidecar-intake-reports."
      ],
      "sourceIds": [
        "gmat"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass.",
        "Customer-use state remains blocked unless source-use rights, runtime validation, economics/materials/resource gates, and reviewer approvals all pass.",
        "A before/after decision-delta artifact is generated and hash-linked to the customer decision dossier ledger."
      ],
      "decisionDeltaContract": {
        "baselineRunLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "comparisonLedgerHash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "scenarioDeltas": [
          {
            "scenarioId": "mercury-orbit",
            "currentRank": 4,
            "currentDecisionLane": "lane-4-research-backlog",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 44.15,
            "currentUncertaintyBudgetPoints": 65.61,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110"
          },
          {
            "scenarioId": "hybrid",
            "currentRank": 2,
            "currentDecisionLane": "lane-3-watchlist",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 59.78,
            "currentUncertaintyBudgetPoints": 43.88,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ],
        "requiredAfterRunFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "replayContract": {
        "planningCommand": "npm run science:report",
        "focusedTestCommand": "node --test tests/scenario-diligence-work-order-ledger.test.mjs",
        "browserProofCommand": "npm run test:browser",
        "expectedOutput": "public/scenario-diligence-work-order-ledger.json",
        "replayBoundary": "This work order scopes diligence execution only. It does not generate the missing source/runtime evidence and cannot promote customer or commercial claims."
      },
      "governance": {
        "currentState": "work-order-planned-blocked-until-evidence",
        "customerUseAllowed": false,
        "commercialUseAllowed": false,
        "sourceUseCustomerAllowed": false,
        "platformRuntimeReady": false,
        "modelValidationCommercialUseAllowed": false,
        "blockedPromotionBoundary": "Treat this as paid-beta diligence backlog, not verified science, legal clearance, operational mission design, investment advice, or resource certification."
      },
      "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
      "evidenceHashes": {
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
      },
      "workOrderHash": "sha256-571ba2ce848959e9016799486d0505720f857685f02a601c2cc09e7f58a3e476"
    },
    {
      "id": "diligence-work-order-03-gap-runtime-tudat-transfer-v1",
      "linkedExperimentId": "experiment-03-gap-runtime-tudat-transfer-v1",
      "linkedExperimentHash": "sha256-a0db28faf34bc01b47e6af539f8df61412fca5bc77e5be23fb978c079b24cd8b",
      "linkedGapId": "gap-runtime-tudat-transfer-v1",
      "linkedGapHash": "sha256-b64edfc79fc195cc5cda74710de1093987b73bb67395866b1a72d3410d82801b",
      "lane": "runtime-validation",
      "priorityLane": "P0-critical-path",
      "priorityScore": 77,
      "title": "Test whether resolving Tudat runtime artifact promotion changes feasibility ranking confidence",
      "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
      "affectedPackageIds": [
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "upstreamAffectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "unmappedScenarioIds": [],
      "scenarioRefs": [
        {
          "scenarioId": "mercury-orbit",
          "dossierId": "customer-dossier-mercury-orbit",
          "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 44.15,
          "uncertaintyBudgetPoints": 65.61,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        },
        {
          "scenarioId": "hybrid",
          "dossierId": "customer-dossier-hybrid",
          "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 59.78,
          "uncertaintyBudgetPoints": 43.88,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        }
      ],
      "requiredInputs": [
        "Runtime-generated sidecar artifact matching the contract.",
        "Tool/environment version and reproducible command.",
        "Inputs, outputs, and checksum hashes.",
        "Independent comparison with residual bounds.",
        "Reviewed sidecar intake report in evidence/sidecar-intake-reports."
      ],
      "sourceIds": [
        "tudat"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass.",
        "Customer-use state remains blocked unless source-use rights, runtime validation, economics/materials/resource gates, and reviewer approvals all pass.",
        "A before/after decision-delta artifact is generated and hash-linked to the customer decision dossier ledger."
      ],
      "decisionDeltaContract": {
        "baselineRunLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "comparisonLedgerHash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "scenarioDeltas": [
          {
            "scenarioId": "mercury-orbit",
            "currentRank": 4,
            "currentDecisionLane": "lane-4-research-backlog",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 44.15,
            "currentUncertaintyBudgetPoints": 65.61,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110"
          },
          {
            "scenarioId": "hybrid",
            "currentRank": 2,
            "currentDecisionLane": "lane-3-watchlist",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 59.78,
            "currentUncertaintyBudgetPoints": 43.88,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ],
        "requiredAfterRunFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "replayContract": {
        "planningCommand": "npm run science:report",
        "focusedTestCommand": "node --test tests/scenario-diligence-work-order-ledger.test.mjs",
        "browserProofCommand": "npm run test:browser",
        "expectedOutput": "public/scenario-diligence-work-order-ledger.json",
        "replayBoundary": "This work order scopes diligence execution only. It does not generate the missing source/runtime evidence and cannot promote customer or commercial claims."
      },
      "governance": {
        "currentState": "work-order-planned-blocked-until-evidence",
        "customerUseAllowed": false,
        "commercialUseAllowed": false,
        "sourceUseCustomerAllowed": false,
        "platformRuntimeReady": false,
        "modelValidationCommercialUseAllowed": false,
        "blockedPromotionBoundary": "Treat this as paid-beta diligence backlog, not verified science, legal clearance, operational mission design, investment advice, or resource certification."
      },
      "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
      "evidenceHashes": {
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
      },
      "workOrderHash": "sha256-74ae877ca9b3c8c030f093f9b35cfd3239f6069c924c1f0da02bf9b6c1d98710"
    },
    {
      "id": "diligence-work-order-04-gap-materials-process-oxygen-isru",
      "linkedExperimentId": "experiment-04-gap-materials-process-oxygen-isru",
      "linkedExperimentHash": "sha256-8751e645da4147db9d9764a6cde76de9722d7a5c403a587bf97fd94ef7b0f06f",
      "linkedGapId": "gap-materials-process-oxygen-isru",
      "linkedGapHash": "sha256-1f55d0f9489776748af577f74f69ae6b3de31dc0cda3196c52dd1ddfe4ae6149",
      "lane": "process-physics",
      "priorityLane": "P1-business-grade",
      "priorityScore": 75,
      "title": "Test whether resolving Oxygen Extraction / ISRU process/material proof changes feasibility ranking confidence",
      "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
      "affectedPackageIds": [
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "moon-first",
        "hybrid"
      ],
      "upstreamAffectedScenarioIds": [
        "moon-first",
        "hybrid",
        "orbital-baseline"
      ],
      "unmappedScenarioIds": [],
      "scenarioRefs": [
        {
          "scenarioId": "moon-first",
          "dossierId": "customer-dossier-moon-first",
          "dossierHash": "sha256-9875bb78ef63e46d736345da0f793778851eafb82f37ef91ca9edde3f3db3573",
          "customerUseState": "paid-beta-internal-diligence",
          "decisionReadinessScore": 62.91,
          "uncertaintyBudgetPoints": 29.81,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        },
        {
          "scenarioId": "hybrid",
          "dossierId": "customer-dossier-hybrid",
          "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 59.78,
          "uncertaintyBudgetPoints": 43.88,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        }
      ],
      "requiredInputs": [
        "feedstock composition with mission/archive citation",
        "reaction pathway and species mechanism",
        "energy-per-kg oxygen or product output",
        "waste/slag stream and equipment degradation assumption",
        "Cantera chemistry/thermodynamics run",
        "thermal reactor or multiphysics energy-balance run"
      ],
      "sourceIds": [
        "nist-chemistry-webbook",
        "materials-project",
        "cantera",
        "moose-framework",
        "pds"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass.",
        "Customer-use state remains blocked unless source-use rights, runtime validation, economics/materials/resource gates, and reviewer approvals all pass.",
        "A before/after decision-delta artifact is generated and hash-linked to the customer decision dossier ledger."
      ],
      "decisionDeltaContract": {
        "baselineRunLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "comparisonLedgerHash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "scenarioDeltas": [
          {
            "scenarioId": "moon-first",
            "currentRank": 1,
            "currentDecisionLane": "lane-2-conditional-diligence",
            "currentCustomerUseState": "paid-beta-internal-diligence",
            "currentDecisionReadinessScore": 62.91,
            "currentUncertaintyBudgetPoints": 29.81,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-9875bb78ef63e46d736345da0f793778851eafb82f37ef91ca9edde3f3db3573"
          },
          {
            "scenarioId": "hybrid",
            "currentRank": 2,
            "currentDecisionLane": "lane-3-watchlist",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 59.78,
            "currentUncertaintyBudgetPoints": 43.88,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ],
        "requiredAfterRunFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "replayContract": {
        "planningCommand": "npm run science:report",
        "focusedTestCommand": "node --test tests/scenario-diligence-work-order-ledger.test.mjs",
        "browserProofCommand": "npm run test:browser",
        "expectedOutput": "public/scenario-diligence-work-order-ledger.json",
        "replayBoundary": "This work order scopes diligence execution only. It does not generate the missing source/runtime evidence and cannot promote customer or commercial claims."
      },
      "governance": {
        "currentState": "work-order-planned-blocked-until-evidence",
        "customerUseAllowed": false,
        "commercialUseAllowed": false,
        "sourceUseCustomerAllowed": false,
        "platformRuntimeReady": false,
        "modelValidationCommercialUseAllowed": false,
        "blockedPromotionBoundary": "Treat this as paid-beta diligence backlog, not verified science, legal clearance, operational mission design, investment advice, or resource certification."
      },
      "nextAction": "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
      "evidenceHashes": {
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
      },
      "workOrderHash": "sha256-bdf99d78b39494df13a8409aa9336affd690e24fd93ec58fdc5b56e258143622"
    },
    {
      "id": "diligence-work-order-05-gap-readiness-science-math-credibility",
      "linkedExperimentId": "experiment-05-gap-readiness-science-math-credibility",
      "linkedExperimentHash": "sha256-9734dd730640f9f7331be94b3fcc73344bd4171a84bc3f75618fe811d479bb3e",
      "linkedGapId": "gap-readiness-science-math-credibility",
      "linkedGapHash": "sha256-e990668e563242845a8877ab591ddcc69ce7794bafe4542918d6313892927c11",
      "lane": "release-proof",
      "priorityLane": "P1-business-grade",
      "priorityScore": 75,
      "title": "Test whether resolving Science/math credibility for beta changes feasibility ranking confidence",
      "buyerQuestion": "Required to raise the beta from testable to release-grade.",
      "affectedPackageIds": [
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "upstreamAffectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "unmappedScenarioIds": [],
      "scenarioRefs": [
        {
          "scenarioId": "mercury-orbit",
          "dossierId": "customer-dossier-mercury-orbit",
          "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 44.15,
          "uncertaintyBudgetPoints": 65.61,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        },
        {
          "scenarioId": "hybrid",
          "dossierId": "customer-dossier-hybrid",
          "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 59.78,
          "uncertaintyBudgetPoints": 43.88,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        }
      ],
      "requiredInputs": [
        "Keep established formulas covered by unit tests and source-integrity tests.",
        "Compare nominal solar irradiance against a cached Horizons Mercury snapshot with explicit tolerance.",
        "Label every planner score as heuristic and prevent heuristic claims from becoming verified physics.",
        "Preserve source query, units, uncertainty, license, and record hash metadata for every promoted model output.",
        "Regenerate deterministic model-artifact bundles before release and block promotion until runtime evidence passes.",
        "Keep seeded uncertainty ranges visible beside deterministic rankings so single-point scenario winners are not overstated."
      ],
      "sourceIds": [],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass.",
        "Customer-use state remains blocked unless source-use rights, runtime validation, economics/materials/resource gates, and reviewer approvals all pass.",
        "A before/after decision-delta artifact is generated and hash-linked to the customer decision dossier ledger."
      ],
      "decisionDeltaContract": {
        "baselineRunLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "comparisonLedgerHash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "scenarioDeltas": [
          {
            "scenarioId": "mercury-orbit",
            "currentRank": 4,
            "currentDecisionLane": "lane-4-research-backlog",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 44.15,
            "currentUncertaintyBudgetPoints": 65.61,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110"
          },
          {
            "scenarioId": "hybrid",
            "currentRank": 2,
            "currentDecisionLane": "lane-3-watchlist",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 59.78,
            "currentUncertaintyBudgetPoints": 43.88,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ],
        "requiredAfterRunFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "replayContract": {
        "planningCommand": "npm run science:report",
        "focusedTestCommand": "node --test tests/scenario-diligence-work-order-ledger.test.mjs",
        "browserProofCommand": "npm run test:browser",
        "expectedOutput": "public/scenario-diligence-work-order-ledger.json",
        "replayBoundary": "This work order scopes diligence execution only. It does not generate the missing source/runtime evidence and cannot promote customer or commercial claims."
      },
      "governance": {
        "currentState": "work-order-planned-blocked-until-evidence",
        "customerUseAllowed": false,
        "commercialUseAllowed": false,
        "sourceUseCustomerAllowed": false,
        "platformRuntimeReady": false,
        "modelValidationCommercialUseAllowed": false,
        "blockedPromotionBoundary": "Treat this as paid-beta diligence backlog, not verified science, legal clearance, operational mission design, investment advice, or resource certification."
      },
      "nextAction": "Source Registry 2.0, assumption registry, scenario notebooks, generated model-artifact bundles, seeded scenario uncertainty analysis, generated economics frontier artifacts, business-case planning heuristics, one SPICE GF runtime artifact, and one OpenMDAO/Dymos beta optimization artifact are now local and tested, but Orekit/GMAT/Tudat runtime artifacts are not yet generated.",
      "evidenceHashes": {
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
      },
      "workOrderHash": "sha256-6e0809c818212af1f7017609be842f01e31c381d04b54fc7f66db8f75606e2d6"
    },
    {
      "id": "diligence-work-order-06-gap-candidate-source-2026-em",
      "linkedExperimentId": "experiment-06-gap-candidate-source-2026-em",
      "linkedExperimentHash": "sha256-972ad36aa06fec061ff2b246e65a74ec9f2c48eb642a309cff0395dd65a049ca",
      "linkedGapId": "gap-candidate-source-2026-em",
      "linkedGapHash": "sha256-d96280eb0a5bb0ddddb50e4dc434eb561b643d420cee73d6e82b9dcc28903531",
      "lane": "resource-confidence",
      "priorityLane": "P1-business-grade",
      "priorityScore": 74,
      "title": "Test whether resolving 2026 EM candidate source custody intake changes feasibility ranking confidence",
      "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
      "affectedPackageIds": [
        "package-asteroid-feedstock-screen-v1",
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "asteroid-first",
        "hybrid"
      ],
      "upstreamAffectedScenarioIds": [
        "asteroid-first",
        "hybrid"
      ],
      "unmappedScenarioIds": [],
      "scenarioRefs": [
        {
          "scenarioId": "asteroid-first",
          "dossierId": "customer-dossier-asteroid-first",
          "dossierHash": "sha256-562059664eb4f97f063fe279404557707fb81da4e4e575591d06ed2b89aad2b1",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 41.63,
          "uncertaintyBudgetPoints": 62.38,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        },
        {
          "scenarioId": "hybrid",
          "dossierId": "customer-dossier-hybrid",
          "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 59.78,
          "uncertaintyBudgetPoints": 43.88,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        }
      ],
      "requiredInputs": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "sourceIds": [
        "sbdb-api",
        "cad-api",
        "mpc",
        "pds"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass.",
        "Customer-use state remains blocked unless source-use rights, runtime validation, economics/materials/resource gates, and reviewer approvals all pass.",
        "A before/after decision-delta artifact is generated and hash-linked to the customer decision dossier ledger."
      ],
      "decisionDeltaContract": {
        "baselineRunLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "comparisonLedgerHash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "scenarioDeltas": [
          {
            "scenarioId": "asteroid-first",
            "currentRank": 3,
            "currentDecisionLane": "lane-4-research-backlog",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 41.63,
            "currentUncertaintyBudgetPoints": 62.38,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-562059664eb4f97f063fe279404557707fb81da4e4e575591d06ed2b89aad2b1"
          },
          {
            "scenarioId": "hybrid",
            "currentRank": 2,
            "currentDecisionLane": "lane-3-watchlist",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 59.78,
            "currentUncertaintyBudgetPoints": 43.88,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ],
        "requiredAfterRunFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "replayContract": {
        "planningCommand": "npm run science:report",
        "focusedTestCommand": "node --test tests/scenario-diligence-work-order-ledger.test.mjs",
        "browserProofCommand": "npm run test:browser",
        "expectedOutput": "public/scenario-diligence-work-order-ledger.json",
        "replayBoundary": "This work order scopes diligence execution only. It does not generate the missing source/runtime evidence and cannot promote customer or commercial claims."
      },
      "governance": {
        "currentState": "work-order-planned-blocked-until-evidence",
        "customerUseAllowed": false,
        "commercialUseAllowed": false,
        "sourceUseCustomerAllowed": false,
        "platformRuntimeReady": false,
        "modelValidationCommercialUseAllowed": false,
        "blockedPromotionBoundary": "Treat this as paid-beta diligence backlog, not verified science, legal clearance, operational mission design, investment advice, or resource certification."
      },
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-em-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-em-source-intake-report.json.",
      "evidenceHashes": {
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
      },
      "workOrderHash": "sha256-ca289d3590ea16900ade0899719bc6f367b45d272c91c2e61f4110ea941a5e16"
    },
    {
      "id": "diligence-work-order-07-gap-candidate-source-2026-jm2",
      "linkedExperimentId": "experiment-07-gap-candidate-source-2026-jm2",
      "linkedExperimentHash": "sha256-ff9fa981fb2bb895602b6de20346e5fe838fa367a44352b977f25c06020990a6",
      "linkedGapId": "gap-candidate-source-2026-jm2",
      "linkedGapHash": "sha256-d4d2c6d76b58c5505d26fdb6d6c4ca999f074c6fff41550d0a977c9d4003a23d",
      "lane": "resource-confidence",
      "priorityLane": "P1-business-grade",
      "priorityScore": 74,
      "title": "Test whether resolving 2026 JM2 candidate source custody intake changes feasibility ranking confidence",
      "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
      "affectedPackageIds": [
        "package-asteroid-feedstock-screen-v1",
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "asteroid-first",
        "hybrid"
      ],
      "upstreamAffectedScenarioIds": [
        "asteroid-first",
        "hybrid"
      ],
      "unmappedScenarioIds": [],
      "scenarioRefs": [
        {
          "scenarioId": "asteroid-first",
          "dossierId": "customer-dossier-asteroid-first",
          "dossierHash": "sha256-562059664eb4f97f063fe279404557707fb81da4e4e575591d06ed2b89aad2b1",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 41.63,
          "uncertaintyBudgetPoints": 62.38,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        },
        {
          "scenarioId": "hybrid",
          "dossierId": "customer-dossier-hybrid",
          "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 59.78,
          "uncertaintyBudgetPoints": 43.88,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        }
      ],
      "requiredInputs": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "sourceIds": [
        "sbdb-api",
        "cad-api",
        "mpc",
        "pds"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass.",
        "Customer-use state remains blocked unless source-use rights, runtime validation, economics/materials/resource gates, and reviewer approvals all pass.",
        "A before/after decision-delta artifact is generated and hash-linked to the customer decision dossier ledger."
      ],
      "decisionDeltaContract": {
        "baselineRunLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "comparisonLedgerHash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "scenarioDeltas": [
          {
            "scenarioId": "asteroid-first",
            "currentRank": 3,
            "currentDecisionLane": "lane-4-research-backlog",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 41.63,
            "currentUncertaintyBudgetPoints": 62.38,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-562059664eb4f97f063fe279404557707fb81da4e4e575591d06ed2b89aad2b1"
          },
          {
            "scenarioId": "hybrid",
            "currentRank": 2,
            "currentDecisionLane": "lane-3-watchlist",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 59.78,
            "currentUncertaintyBudgetPoints": 43.88,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ],
        "requiredAfterRunFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "replayContract": {
        "planningCommand": "npm run science:report",
        "focusedTestCommand": "node --test tests/scenario-diligence-work-order-ledger.test.mjs",
        "browserProofCommand": "npm run test:browser",
        "expectedOutput": "public/scenario-diligence-work-order-ledger.json",
        "replayBoundary": "This work order scopes diligence execution only. It does not generate the missing source/runtime evidence and cannot promote customer or commercial claims."
      },
      "governance": {
        "currentState": "work-order-planned-blocked-until-evidence",
        "customerUseAllowed": false,
        "commercialUseAllowed": false,
        "sourceUseCustomerAllowed": false,
        "platformRuntimeReady": false,
        "modelValidationCommercialUseAllowed": false,
        "blockedPromotionBoundary": "Treat this as paid-beta diligence backlog, not verified science, legal clearance, operational mission design, investment advice, or resource certification."
      },
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jm2-source-intake-report.json.",
      "evidenceHashes": {
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
      },
      "workOrderHash": "sha256-708045573dcd7b1b11a8d0644a1306575d7ae399481f6842235f66802c679332"
    },
    {
      "id": "diligence-work-order-08-gap-candidate-source-2026-dn5",
      "linkedExperimentId": "experiment-08-gap-candidate-source-2026-dn5",
      "linkedExperimentHash": "sha256-621f7f959d977f2998b77ff251eea55b0e839c42b3d91f113185ab969381042d",
      "linkedGapId": "gap-candidate-source-2026-dn5",
      "linkedGapHash": "sha256-72469172df74568bab75cf56d7fdf37aa178bfdf0ae0ffb65fd6d6b9e1acd433",
      "lane": "resource-confidence",
      "priorityLane": "P1-business-grade",
      "priorityScore": 73,
      "title": "Test whether resolving 2026 DN5 candidate source custody intake changes feasibility ranking confidence",
      "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
      "affectedPackageIds": [
        "package-asteroid-feedstock-screen-v1",
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "asteroid-first",
        "hybrid"
      ],
      "upstreamAffectedScenarioIds": [
        "asteroid-first",
        "hybrid"
      ],
      "unmappedScenarioIds": [],
      "scenarioRefs": [
        {
          "scenarioId": "asteroid-first",
          "dossierId": "customer-dossier-asteroid-first",
          "dossierHash": "sha256-562059664eb4f97f063fe279404557707fb81da4e4e575591d06ed2b89aad2b1",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 41.63,
          "uncertaintyBudgetPoints": 62.38,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        },
        {
          "scenarioId": "hybrid",
          "dossierId": "customer-dossier-hybrid",
          "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 59.78,
          "uncertaintyBudgetPoints": 43.88,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        }
      ],
      "requiredInputs": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "sourceIds": [
        "sbdb-api",
        "cad-api",
        "mpc",
        "pds"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass.",
        "Customer-use state remains blocked unless source-use rights, runtime validation, economics/materials/resource gates, and reviewer approvals all pass.",
        "A before/after decision-delta artifact is generated and hash-linked to the customer decision dossier ledger."
      ],
      "decisionDeltaContract": {
        "baselineRunLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "comparisonLedgerHash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "scenarioDeltas": [
          {
            "scenarioId": "asteroid-first",
            "currentRank": 3,
            "currentDecisionLane": "lane-4-research-backlog",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 41.63,
            "currentUncertaintyBudgetPoints": 62.38,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-562059664eb4f97f063fe279404557707fb81da4e4e575591d06ed2b89aad2b1"
          },
          {
            "scenarioId": "hybrid",
            "currentRank": 2,
            "currentDecisionLane": "lane-3-watchlist",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 59.78,
            "currentUncertaintyBudgetPoints": 43.88,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ],
        "requiredAfterRunFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "replayContract": {
        "planningCommand": "npm run science:report",
        "focusedTestCommand": "node --test tests/scenario-diligence-work-order-ledger.test.mjs",
        "browserProofCommand": "npm run test:browser",
        "expectedOutput": "public/scenario-diligence-work-order-ledger.json",
        "replayBoundary": "This work order scopes diligence execution only. It does not generate the missing source/runtime evidence and cannot promote customer or commercial claims."
      },
      "governance": {
        "currentState": "work-order-planned-blocked-until-evidence",
        "customerUseAllowed": false,
        "commercialUseAllowed": false,
        "sourceUseCustomerAllowed": false,
        "platformRuntimeReady": false,
        "modelValidationCommercialUseAllowed": false,
        "blockedPromotionBoundary": "Treat this as paid-beta diligence backlog, not verified science, legal clearance, operational mission design, investment advice, or resource certification."
      },
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-dn5-source-intake-report.json.",
      "evidenceHashes": {
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
      },
      "workOrderHash": "sha256-7aba6c179ff641753e4dcf699a4c2e196f07d7a2ebadbb931690035802d2f143"
    },
    {
      "id": "diligence-work-order-09-gap-materials-process-spf-db",
      "linkedExperimentId": "experiment-09-gap-materials-process-spf-db",
      "linkedExperimentHash": "sha256-5d5ec994e2cf1ef71a7b714db2cca45bea73154371e4a7a12c743d274a53bc77",
      "linkedGapId": "gap-materials-process-spf-db",
      "linkedGapHash": "sha256-ae0748a11a838e23082f8103c11c90d9fe916318d6c4fc39df463393ee9e2e33",
      "lane": "process-physics",
      "priorityLane": "P1-business-grade",
      "priorityScore": 73,
      "title": "Test whether resolving Superplastic Forming / Diffusion Bonding process/material proof changes feasibility ranking confidence",
      "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
      "affectedPackageIds": [
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "upstreamAffectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "unmappedScenarioIds": [],
      "scenarioRefs": [
        {
          "scenarioId": "mercury-orbit",
          "dossierId": "customer-dossier-mercury-orbit",
          "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 44.15,
          "uncertaintyBudgetPoints": 65.61,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        },
        {
          "scenarioId": "hybrid",
          "dossierId": "customer-dossier-hybrid",
          "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 59.78,
          "uncertaintyBudgetPoints": 43.88,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        }
      ],
      "requiredInputs": [
        "alloy and grain-size condition",
        "forming temperature and strain-rate window",
        "diffusion-bonding pressure/time/temperature window",
        "die/tooling mass and thermal distortion model",
        "thermal cycle energy balance",
        "forming/diffusion-bonding process model"
      ],
      "sourceIds": [
        "nist-codata",
        "nist-chemistry-webbook",
        "materials-project",
        "moose-framework",
        "openfoam"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass.",
        "Customer-use state remains blocked unless source-use rights, runtime validation, economics/materials/resource gates, and reviewer approvals all pass.",
        "A before/after decision-delta artifact is generated and hash-linked to the customer decision dossier ledger."
      ],
      "decisionDeltaContract": {
        "baselineRunLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "comparisonLedgerHash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "scenarioDeltas": [
          {
            "scenarioId": "mercury-orbit",
            "currentRank": 4,
            "currentDecisionLane": "lane-4-research-backlog",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 44.15,
            "currentUncertaintyBudgetPoints": 65.61,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110"
          },
          {
            "scenarioId": "hybrid",
            "currentRank": 2,
            "currentDecisionLane": "lane-3-watchlist",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 59.78,
            "currentUncertaintyBudgetPoints": 43.88,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ],
        "requiredAfterRunFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "replayContract": {
        "planningCommand": "npm run science:report",
        "focusedTestCommand": "node --test tests/scenario-diligence-work-order-ledger.test.mjs",
        "browserProofCommand": "npm run test:browser",
        "expectedOutput": "public/scenario-diligence-work-order-ledger.json",
        "replayBoundary": "This work order scopes diligence execution only. It does not generate the missing source/runtime evidence and cannot promote customer or commercial claims."
      },
      "governance": {
        "currentState": "work-order-planned-blocked-until-evidence",
        "customerUseAllowed": false,
        "commercialUseAllowed": false,
        "sourceUseCustomerAllowed": false,
        "platformRuntimeReady": false,
        "modelValidationCommercialUseAllowed": false,
        "blockedPromotionBoundary": "Treat this as paid-beta diligence backlog, not verified science, legal clearance, operational mission design, investment advice, or resource certification."
      },
      "nextAction": "Promote reviewed material records and thermal cycle energy balance for Superplastic Forming / Diffusion Bonding.",
      "evidenceHashes": {
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
      },
      "workOrderHash": "sha256-0f76d2cba16f3e50d606a4ca6ba58e7b0b55ff94806314a9f1fc37a2016034b4"
    },
    {
      "id": "diligence-work-order-10-gap-materials-process-vacuum-sheet",
      "linkedExperimentId": "experiment-10-gap-materials-process-vacuum-sheet",
      "linkedExperimentHash": "sha256-51cf969b59ea135750246e39bdd97fd8cd24d18c67c906daa44517646ca56074",
      "linkedGapId": "gap-materials-process-vacuum-sheet",
      "linkedGapHash": "sha256-8962058e82d93ebe648b6aa41c8720a622df2d1c66100a9837288e03a9aff4e0",
      "lane": "process-physics",
      "priorityLane": "P1-business-grade",
      "priorityScore": 73,
      "title": "Test whether resolving Vacuum Anisotropic Sheet Manufacturing process/material proof changes feasibility ranking confidence",
      "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
      "affectedPackageIds": [
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "upstreamAffectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "unmappedScenarioIds": [],
      "scenarioRefs": [
        {
          "scenarioId": "mercury-orbit",
          "dossierId": "customer-dossier-mercury-orbit",
          "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 44.15,
          "uncertaintyBudgetPoints": 65.61,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        },
        {
          "scenarioId": "hybrid",
          "dossierId": "customer-dossier-hybrid",
          "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 59.78,
          "uncertaintyBudgetPoints": 43.88,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        }
      ],
      "requiredInputs": [
        "candidate alloy or sheet material identifier",
        "temperature-dependent elastic/plastic property table",
        "vacuum-compatible joining/forming process window",
        "non-destructive evaluation limit and acceptance criterion",
        "MOOSE thermo-mechanical forming residual record",
        "OpenFOAM or equivalent thermal-control case record"
      ],
      "sourceIds": [
        "nist-codata",
        "materials-project",
        "moose-framework",
        "openfoam",
        "pds"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass.",
        "Customer-use state remains blocked unless source-use rights, runtime validation, economics/materials/resource gates, and reviewer approvals all pass.",
        "A before/after decision-delta artifact is generated and hash-linked to the customer decision dossier ledger."
      ],
      "decisionDeltaContract": {
        "baselineRunLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "comparisonLedgerHash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "scenarioDeltas": [
          {
            "scenarioId": "mercury-orbit",
            "currentRank": 4,
            "currentDecisionLane": "lane-4-research-backlog",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 44.15,
            "currentUncertaintyBudgetPoints": 65.61,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110"
          },
          {
            "scenarioId": "hybrid",
            "currentRank": 2,
            "currentDecisionLane": "lane-3-watchlist",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 59.78,
            "currentUncertaintyBudgetPoints": 43.88,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ],
        "requiredAfterRunFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "replayContract": {
        "planningCommand": "npm run science:report",
        "focusedTestCommand": "node --test tests/scenario-diligence-work-order-ledger.test.mjs",
        "browserProofCommand": "npm run test:browser",
        "expectedOutput": "public/scenario-diligence-work-order-ledger.json",
        "replayBoundary": "This work order scopes diligence execution only. It does not generate the missing source/runtime evidence and cannot promote customer or commercial claims."
      },
      "governance": {
        "currentState": "work-order-planned-blocked-until-evidence",
        "customerUseAllowed": false,
        "commercialUseAllowed": false,
        "sourceUseCustomerAllowed": false,
        "platformRuntimeReady": false,
        "modelValidationCommercialUseAllowed": false,
        "blockedPromotionBoundary": "Treat this as paid-beta diligence backlog, not verified science, legal clearance, operational mission design, investment advice, or resource certification."
      },
      "nextAction": "Promote reviewed material records and MOOSE thermo-mechanical forming residual record for Vacuum Anisotropic Sheet Manufacturing.",
      "evidenceHashes": {
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
      },
      "workOrderHash": "sha256-ef9e747934d358294e2459299e33ef07454fd7880972a251177e083cda4c7169"
    },
    {
      "id": "diligence-work-order-11-gap-resource-taxonomy-spectra-record",
      "linkedExperimentId": "experiment-11-gap-resource-taxonomy-spectra-record",
      "linkedExperimentHash": "sha256-616e307887247bafb93aa08e62c3253dedd7030096b17c7c599af575b299b07f",
      "linkedGapId": "gap-resource-taxonomy-spectra-record",
      "linkedGapHash": "sha256-9db13bf7dcfd4714e258eaf1832f2100875911d77f71633f871082fd8ae097ff",
      "lane": "resource-confidence",
      "priorityLane": "P1-business-grade",
      "priorityScore": 73,
      "title": "Test whether resolving Taxonomy or spectra record changes feasibility ranking confidence",
      "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
      "affectedPackageIds": [
        "package-asteroid-feedstock-screen-v1",
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "asteroid-first",
        "hybrid"
      ],
      "upstreamAffectedScenarioIds": [
        "asteroid-first",
        "hybrid"
      ],
      "unmappedScenarioIds": [],
      "scenarioRefs": [
        {
          "scenarioId": "asteroid-first",
          "dossierId": "customer-dossier-asteroid-first",
          "dossierHash": "sha256-562059664eb4f97f063fe279404557707fb81da4e4e575591d06ed2b89aad2b1",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 41.63,
          "uncertaintyBudgetPoints": 62.38,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        },
        {
          "scenarioId": "hybrid",
          "dossierId": "customer-dossier-hybrid",
          "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 59.78,
          "uncertaintyBudgetPoints": 43.88,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        }
      ],
      "requiredInputs": [
        "Resource-class evidence; close approaches cannot imply composition."
      ],
      "sourceIds": [
        "pds",
        "esa-psa",
        "jaxa-darts"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass.",
        "Customer-use state remains blocked unless source-use rights, runtime validation, economics/materials/resource gates, and reviewer approvals all pass.",
        "A before/after decision-delta artifact is generated and hash-linked to the customer decision dossier ledger."
      ],
      "decisionDeltaContract": {
        "baselineRunLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "comparisonLedgerHash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "scenarioDeltas": [
          {
            "scenarioId": "asteroid-first",
            "currentRank": 3,
            "currentDecisionLane": "lane-4-research-backlog",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 41.63,
            "currentUncertaintyBudgetPoints": 62.38,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-562059664eb4f97f063fe279404557707fb81da4e4e575591d06ed2b89aad2b1"
          },
          {
            "scenarioId": "hybrid",
            "currentRank": 2,
            "currentDecisionLane": "lane-3-watchlist",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 59.78,
            "currentUncertaintyBudgetPoints": 43.88,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ],
        "requiredAfterRunFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "replayContract": {
        "planningCommand": "npm run science:report",
        "focusedTestCommand": "node --test tests/scenario-diligence-work-order-ledger.test.mjs",
        "browserProofCommand": "npm run test:browser",
        "expectedOutput": "public/scenario-diligence-work-order-ledger.json",
        "replayBoundary": "This work order scopes diligence execution only. It does not generate the missing source/runtime evidence and cannot promote customer or commercial claims."
      },
      "governance": {
        "currentState": "work-order-planned-blocked-until-evidence",
        "customerUseAllowed": false,
        "commercialUseAllowed": false,
        "sourceUseCustomerAllowed": false,
        "platformRuntimeReady": false,
        "modelValidationCommercialUseAllowed": false,
        "blockedPromotionBoundary": "Treat this as paid-beta diligence backlog, not verified science, legal clearance, operational mission design, investment advice, or resource certification."
      },
      "nextAction": "Attach Taxonomy or spectra record records for candidate objects with hashes and source citations.",
      "evidenceHashes": {
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
      },
      "workOrderHash": "sha256-ce13be2de8e222b90b3f72ab64e82567f72bc328ddf50d0cdf34b08ecf7cd089"
    },
    {
      "id": "diligence-work-order-12-gap-economics-launch-list-price-source",
      "linkedExperimentId": "experiment-12-gap-economics-launch-list-price-source",
      "linkedExperimentHash": "sha256-9cc9a2319a1e5831df6bac5cb44054e51d74d644d97c6879b13682c92bdeace7",
      "linkedGapId": "gap-economics-launch-list-price-source",
      "linkedGapHash": "sha256-9ec3287429344e07a1ef221f40ac591b8ee993eed464f232f27c9cba41776d15",
      "lane": "economics-sensitivity",
      "priorityLane": "P1-business-grade",
      "priorityScore": 71,
      "title": "Test whether resolving Launch list-price source intake changes feasibility ranking confidence",
      "buyerQuestion": "Do dated, normalized cost and market inputs change the scenario ranking or capital gap?",
      "affectedPackageIds": [
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "moon-first",
        "hybrid"
      ],
      "upstreamAffectedScenarioIds": [
        "moon-first",
        "hybrid",
        "orbital-baseline"
      ],
      "unmappedScenarioIds": [],
      "scenarioRefs": [
        {
          "scenarioId": "moon-first",
          "dossierId": "customer-dossier-moon-first",
          "dossierHash": "sha256-9875bb78ef63e46d736345da0f793778851eafb82f37ef91ca9edde3f3db3573",
          "customerUseState": "paid-beta-internal-diligence",
          "decisionReadinessScore": 62.91,
          "uncertaintyBudgetPoints": 29.81,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        },
        {
          "scenarioId": "hybrid",
          "dossierId": "customer-dossier-hybrid",
          "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb",
          "customerUseState": "research-backlog-only",
          "decisionReadinessScore": 59.78,
          "uncertaintyBudgetPoints": 43.88,
          "firstBlockingProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
        }
      ],
      "requiredInputs": [
        "Extract published price table with access timestamp.",
        "Normalize to USD/kg only for the stated payload/orbit class.",
        "Record mission-specific integration, insurance, rideshare constraints, and schedule caveats."
      ],
      "sourceIds": [
        "spacex-rideshare"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass.",
        "Customer-use state remains blocked unless source-use rights, runtime validation, economics/materials/resource gates, and reviewer approvals all pass.",
        "A before/after decision-delta artifact is generated and hash-linked to the customer decision dossier ledger."
      ],
      "decisionDeltaContract": {
        "baselineRunLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "comparisonLedgerHash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "scenarioDeltas": [
          {
            "scenarioId": "moon-first",
            "currentRank": 1,
            "currentDecisionLane": "lane-2-conditional-diligence",
            "currentCustomerUseState": "paid-beta-internal-diligence",
            "currentDecisionReadinessScore": 62.91,
            "currentUncertaintyBudgetPoints": 29.81,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-9875bb78ef63e46d736345da0f793778851eafb82f37ef91ca9edde3f3db3573"
          },
          {
            "scenarioId": "hybrid",
            "currentRank": 2,
            "currentDecisionLane": "lane-3-watchlist",
            "currentCustomerUseState": "research-backlog-only",
            "currentDecisionReadinessScore": 59.78,
            "currentUncertaintyBudgetPoints": 43.88,
            "currentBlockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ],
        "requiredAfterRunFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "replayContract": {
        "planningCommand": "npm run science:report",
        "focusedTestCommand": "node --test tests/scenario-diligence-work-order-ledger.test.mjs",
        "browserProofCommand": "npm run test:browser",
        "expectedOutput": "public/scenario-diligence-work-order-ledger.json",
        "replayBoundary": "This work order scopes diligence execution only. It does not generate the missing source/runtime evidence and cannot promote customer or commercial claims."
      },
      "governance": {
        "currentState": "work-order-planned-blocked-until-evidence",
        "customerUseAllowed": false,
        "commercialUseAllowed": false,
        "sourceUseCustomerAllowed": false,
        "platformRuntimeReady": false,
        "modelValidationCommercialUseAllowed": false,
        "blockedPromotionBoundary": "Treat this as paid-beta diligence backlog, not verified science, legal clearance, operational mission design, investment advice, or resource certification."
      },
      "nextAction": "Normalize launch-cost records into model-ready numeric inputs with calibration artifacts.",
      "evidenceHashes": {
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
      },
      "workOrderHash": "sha256-98529615ecd1f236b1f6ea583e4019269b6871fe39b3b94d8d0dc2b797ce60e6"
    }
  ],
  "ledgerHash": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a"
}
;
